import { css } from "@emotion/react";
import styled from "@emotion/styled";

import IconSearchCancel from "./icon-search-cancel.svg";
import IconSearch from "./icon-search.svg";

export const StyledIconSearch = styled(IconSearch)`
  inline-size: 23px;
  block-size: 23px;
`;

export const SearchInputContainer = styled.div`
  position: relative;

  display: none;
  flex: 0;

  padding-inline-start: 8px;
`;

export const SearchInput = styled.input`
  inline-size: 100%;
  box-sizing: border-box;

  color: #222834;
  font-size: 16px;
  line-height: 19px;

  border: 0;

  background-color: transparent;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: rgba(34, 40, 52, 0.5);
  }
`;

export const StyledIconSearchCancel = styled(IconSearchCancel)`
  inset-block-start: 2px;
  inset-inline-end: 11.5px;

  display: none;

  inline-size: 18px;
  block-size: 19px;

  color: #777777;

  user-select: none;
`;

type WrapperProps = {
  $isExpanded: boolean;
};
export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  float: inline-end;

  inline-size: ${props => (props.$isExpanded ? "100%" : "41px")};
  block-size: 41px;
  padding-block: 0;
  padding-inline: 9px;
  box-sizing: border-box;

  border-radius: 41px;

  background-color: #a7a9ae;

  cursor: pointer;

  overflow: hidden;

  transition: all;
  transition-timing-function: ease-in-out;
  transition-duration: 0.3s;

  ${props =>
    props.$isExpanded
      ? css`
          ${StyledIconSearch} {
            pointer-events: none;
          }

          ${SearchInputContainer} {
            display: block;
            flex: 1;
          }
          ${StyledIconSearchCancel} {
            display: block;
          }
        `
      : null}
`;

export const Container = styled.div``;
